import objectPath from 'object-path'
import { shouldUpdateFetchOptionStatus } from '../../action/condition/FetchOption.util'

export const isRuleFetchOptionAction = (action = {}) => {
  return action.type === 'updateOption'
}

const getRuleFetchOptionTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

const addRuleFetchOptionTargetKey = (keys = [], key = '') => {
  if (!key) return keys
  if (keys.includes(key)) return keys

  keys.push(key)
  return keys
}

const addRuleFetchOptionPathKeys = (keys = [], key = '') => {
  addRuleFetchOptionTargetKey(keys, key)

  let keyList = String(key || '')
    .split('.')
    .filter((value) => value)

  if (keyList.length > 1) {
    addRuleFetchOptionTargetKey(keys, keyList[keyList.length - 1])
  }

  return keys
}

const getRuleFetchOptionTargetKeys = (
  designContext = {},
  action = {},
  target = '',
) => {
  let { jsonForm = {} } = designContext
  let rawTarget = getRuleFetchOptionTarget(action, target)
  let keys = []
  let mapKey = objectPath.get(jsonForm, 'schema.mapKey') || {}
  let mapName = objectPath.get(jsonForm, 'schema.mapName') || {}

  addRuleFetchOptionPathKeys(keys, rawTarget)

  const addSchemaMapTargetKeys = (schemaMap = {}) => {
    Object.keys(schemaMap).forEach((mapFieldKey) => {
      let mapValue = schemaMap[mapFieldKey] || ''
      let isMatched =
        mapFieldKey === rawTarget ||
        mapValue === rawTarget ||
        String(rawTarget || '').endsWith(`.${mapFieldKey}`) ||
        String(mapValue || '').endsWith(`.${rawTarget}`)

      if (!isMatched) return

      addRuleFetchOptionTargetKey(keys, mapFieldKey)
      addRuleFetchOptionPathKeys(keys, mapValue)
    })
  }

  addSchemaMapTargetKeys(mapKey)
  addSchemaMapTargetKeys(mapName)

  return keys
}

const getRuleFetchOptionStatus = (status = {}) => {
  let {
    isDynamic,
    dynamicName,
    dynamicKey,
    dynamicIndex,
    formComponentName,
    ruleUiKeys,
    valueChange,
    eventKey,
  } = status

  return {
    isDynamic,
    dynamicName,
    dynamicKey,
    dynamicIndex,
    formComponentName,
    ruleUiKeys,
    valueChange,
    eventKey,
  }
}

const setRuleFetchOptionElementAction = (
  designContext = {},
  targetKey,
) => {
  let { elementAction = {}, setElementAction } = designContext
  let updateOption = objectPath.get(elementAction, ['updateOption']) || []
  let isChanged = false

  if (!Array.isArray(updateOption)) {
    updateOption = []
    isChanged = true
  }
  if (!updateOption.includes(targetKey)) {
    updateOption.push(targetKey)
    isChanged = true
  }

  if (!isChanged) return

  objectPath.set(elementAction, ['updateOption'], updateOption)
  if (setElementAction) setElementAction(elementAction)
}

const setRuleFetchOptionElementActions = (
  designContext = {},
  targetKeys = [],
) => {
  targetKeys.forEach((targetKey) => {
    setRuleFetchOptionElementAction(designContext, targetKey)
  })
}

const setRuleFetchOptionUiChanged = (
  designContext = {},
  targetKey,
  status = {},
) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext
  let { formComponentName, ...fetchStatus } = status
  let isFetchOption = {
    key: targetKey,
    forceFetch: Date.now(),
    ...fetchStatus,
  }

  if (
    !shouldUpdateFetchOptionStatus({
      isUiChanged,
      key: targetKey,
      formComponentName,
      isFetchOption,
      fetchStatus,
    })
  ) {
    return
  }

  objectPath.set(isUiChanged, ['optionUpdate', targetKey], fetchStatus)

  if (formComponentName) {
    objectPath.set(isUiChanged, `${formComponentName}.${targetKey}`, {
      isRender: true,
      isFetchOption,
    })
  } else {
    objectPath.set(isUiChanged, [targetKey, 'isRender'], true)
    objectPath.set(isUiChanged, ['isFetchOption', targetKey], isFetchOption)
  }

  if (setIsUiChanged) setIsUiChanged(isUiChanged)
}

const setRuleFetchOptionUiChanges = (
  designContext = {},
  targetKeys = [],
  status = {},
) => {
  targetKeys.forEach((targetKey) => {
    setRuleFetchOptionUiChanged(designContext, targetKey, status)
  })
}

export const onRuleFetchOption = (
  designContext = {},
  action = {},
  status = {},
  target = '',
) => {
  let targetKeys = getRuleFetchOptionTargetKeys(designContext, action, target)
  let targetKey = targetKeys[0]
  if (!targetKeys.length) {
    return undefined
  }

  let fetchStatus = getRuleFetchOptionStatus(status)

  setRuleFetchOptionElementActions(designContext, targetKeys)
  setRuleFetchOptionUiChanges(designContext, targetKeys, fetchStatus)

  return {
    key: targetKey,
    targetKeys,
    ...fetchStatus,
  }
}
